import { collectNumbers, ichimokuSeries, numericExtent } from "../utils";
const ICHIMOKU = {
    name: "Ichimoku",
    compute: (bars, tenkan = 9, kijun = 26, senkouB = 52, displacement = 26) => {
        return ichimokuSeries(bars, tenkan, kijun, senkouB, displacement);
    },
    computeExtents: (values) => numericExtent(collectNumbers(values)),
    render: () => undefined,
};
export default ICHIMOKU;
